import React from 'react'
import { Link } from 'gatsby'
import ListasStyle from '../ListasStyle'

const LinkOrExternal = ({ link, children }) => {
  if (link && link.startsWith('http')) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    )
  }
  return <Link to={link}>{children}</Link>
}

const Listas = ({ title, description, list }) => {
  return (
    <ListasStyle
      header={
        <div>
          <h2 className="mt-6 mb-2 text-4xl font-bold leading-none text-center">
            {title}
          </h2>
          <p className="text-left text-gray-600">{description}</p>
        </div>
      }>
      <div className="listas-home-block__list">
        {list.map((item, index) => (
          <nav
            key={index}
            className="py-3 -mx-3 sm:py-6 sm:-mx-8 listas-home-block__list border-b-1 sm:px-8 first:border-t-1 last:border-b-0">
            <div className="listas-home-block__list-title">
              <h3 className="mb-2 text-xl font-bold leading-none text-left">
                <LinkOrExternal link={item.link}>
                  <span dangerouslySetInnerHTML={{ __html: item.title }}></span>
                </LinkOrExternal>
              </h3>
              <p className="pb-0 text-left text-gray-600">
                <LinkOrExternal link={item.link}>
                  <span
                    dangerouslySetInnerHTML={{
                      __html: item.description,
                    }}></span>
                </LinkOrExternal>
              </p>
            </div>
          </nav>
        ))}
      </div>
    </ListasStyle>
  )
}

export default Listas
